import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import configReducer from './slices/configSlice';
import adminAuthReducer from './slices/adminAuthSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    config: configReducer,
    adminAuth: adminAuthReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar acciones que no son serializables (como funciones)
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Exponer store globalmente en desarrollo para debuggear
if (process.env.NODE_ENV === 'development') {
  window.store = store;
} 